import { Flex, Skeleton, VStack } from '@chakra-ui/react';

const InvitationMessageCardSkeleton = () => (
  <VStack gap={4} p={4} bg="gray.subtle" rounded="xl" w="full">
    <Flex justify="space-between" align="center" w="full">
      <Skeleton height="28px" width="120px" bg="white" />
      <Skeleton height="32px" width="80px" bg="white" />
    </Flex>
    <Skeleton height="140px" width="full" bg="white" rounded="xl" />
  </VStack>
);

export default InvitationMessageCardSkeleton;
